export default "__VITE_ASSET__8ccc8984__"